import type { AuditoriaFiltersState } from "../types/auditoria.types";

function hasNumericAmountFilter(value: string): boolean {
  const t = value?.trim().replace(",", ".") ?? "";
  if (!t) return false;
  return Number.isFinite(Number(t));
}

export function showPaymentExtendedTableColumns(filters: AuditoriaFiltersState): boolean {
  if (filters.flujo === "PAYMENT") return true;
  if (filters.clientId?.trim()) return true;
  if (filters.organizationId?.trim()) return true;
  if (filters.paymentCurrency?.trim()) return true;
  if (hasNumericAmountFilter(filters.paymentAmountMin)) return true;
  if (hasNumericAmountFilter(filters.paymentAmountMax)) return true;
  return false;
}
